import { render, staticRenderFns } from "./memberAddressEditComponent.vue?vue&type=template&id=3846fd86&"
import script from "./memberAddressEditComponent.vue?vue&type=script&lang=ts&"
export * from "./memberAddressEditComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports